// Car data extracted from data.js — with image URLs from deployed build.
const BASE = "https://arlindi3.github.io/froler-website/static/media/";

const seedCars = [
  {
    name: "Mercedes-Benz GLC 250d 4MATIC",
    slug: "mercedes-glc",
    type: "SUV",
    price: 25000,
    km: "",
    year: 2019,
    size: 72,
    carMake: "Mercedes-Benz",
    gps: true,
    sportPackage: false,
    featured: false,
    description:
      "🚗 Shitet Mercedes-Benz GLC 250d 4MATIC – Viti 2016 🇨🇭 Importuar nga Zvicra – Gjendje perfekte! ✨ Full opsion 🔧4x4 (4MATIC) – Gati për çdo terren",
    extras: [
      "Navigator + GPS",
      "Kamera parkimi + sensor parkimi",
      "Sallon lekure",
      "Distronic (ruajtje distance automatike)",
      "Drita Bi-Xenon & LED",
      "4x4 (4MATIC)",
    ],
    images: [
      BASE + "car1.7276790015b0b2485c97.jpeg",
      BASE + "details1.36fefde7401c5da1d9e0.jpeg",
      BASE + "details2.71a085637dc40504eb08.jpeg",
      BASE + "details3.533e3a348845a4cf5de7.jpeg",
      BASE + "details4.b8b83bb5c6a8fd7f4884.jpeg",
      BASE + "details5.c4bb1dd08e772d5e7296.jpeg",
      BASE + "details6.316d9cc7ddc14e938179.jpeg",
      BASE + "details7.e4709daf51800787904d.jpeg",
    ],
  },
  {
    name: "Mercedes CLS 450 AMG",
    slug: "mercedes-cls",
    type: "SEDAN",
    price: "Kontakto",
    km: "11.000",
    year: 2019,
    size: 72,
    carMake: "Mercedes-Benz",
    gps: true,
    sportPackage: true,
    featured: false,
    description:
      "🚘 Mercedes CLS 450 AMG📅 Viti: 2019 | 🛢️ 3.0 Benzin Vetem 11.000Km✨ Look AMG nga fabrika — elegancë dhe agresivitet në një trup të vetëm!",
    extras: [
      "Kamera 360° & Sensorë 360°",
      "Hapse panoramike xhami për një përvojë luksoze",
      "Distronic Plus – lëviz me siguri maksimale",
      "Blind Spot Assist – gjithmonë në kontroll",
      "Asistencë korsie",
      "Sedilje me memorie + ngrohje + ftohje",
      "Sistemi audio Burmester – muzika si në studio",
    ],
    images: [
      BASE + "car2.9ed4cca8de64486a685d.jpeg",
      BASE + "detailsCls1.ac2b2ca5c09dbbf1a988.jpeg",
      BASE + "detailsCls%20(2).55b03810998df5e19165.jpeg",
      BASE + "detailsCls%20(3).8601a69ae21a62071d17.jpeg",
      BASE + "detailsCls%20(4).56d95d6461bdd40c872a.jpeg",
      BASE + "detailsCls%20(5).7c753b438c28f4b259a3.jpeg",
      BASE + "detailsCls%20(6).a4e449809b77120239c0.jpeg",
      BASE + "detailsCls%20(7).afa00866cf797b18610c.jpeg",
      BASE + "detailsCls%20(8).da4034b3ac91199cdf68.jpeg",
      BASE + "detailsCls%20(9).fadaa93e0ac18f3df749.jpeg",
    ],
  },
  {
    name: "Mercedes GLE 350d 4MATIC - AMG Look",
    slug: "mercedes-gle",
    type: "SUV",
    price: "Kontakto",
    km: "130.000",
    year: 2020,
    size: 72,
    carMake: "Mercedes-Benz",
    gps: true,
    sportPackage: false,
    featured: false,
    description:
      "📢 Shitet Mercedes GLE 350d 4MATIC - AMG Look 📆 Viti: 2020 ℹ️130,000Km 🖤 Ngjyrë: E zezë",
    extras: [
      "Panoram",
      "Burmester",
      "Hapje mbyllje ndezje pa çelës",
      "Head Up Display",
      "Dritat Full Led Inteligjente",
      "Camera 360°",
      "Distronic + Asistencë Korsie",
    ],
    images: [
      BASE + "car3.6115603b5dc594d40bd2.jpeg",
      BASE + "detailsGle%20(1).47f832b8ce753051a766.jpeg",
      BASE + "detailsGle%20(2).5b169be60c920d81527c.jpeg",
      BASE + "detailsGle%20(3).e4003b76880c8fd4b97a.jpeg",
      BASE + "detailsGle%20(4).52813143f12049ae95d2.jpeg",
      BASE + "detailsGle%20(5).4d8014d793420f2e9eb8.jpeg",
      BASE + "detailsGle%20(6).f4ffb55914261fe793b9.jpeg",
      BASE + "detailsGle%20(7).b5387058255ef51d1af3.jpeg",
      BASE + "detailsGle%20(8).fef0b0c640b3df6cb898.jpeg",
    ],
  },
  {
    name: "Range Rover Vogue 4.4 TDV8 – Facelift",
    slug: "range-vogue",
    type: "SUV",
    price: "Kontakto",
    km: "",
    year: 2019,
    size: 72,
    carMake: "Range-Rover",
    gps: true,
    sportPackage: true,
    featured: false,
    description:
      "🇩🇪🇩🇪Range Rover Vogue 4.4 TDV8 – 2019 Facelift Luks, fuqi dhe rehati në maksimum!🇩🇪🇩🇪 Importuar Nga Gjermania",
    extras: [
      "Panoram & Head-Up Display",
      "360° Kamera & Sedilje me memorie, ngrohje, ftohje, masazh",
      "Dyer me thithje & Hapje Mbyllje Ndezje pa çelës",
      "Klimë 3-zonëshe",
    ],
    images: [
      BASE + "car4.c5f010954434d75cbc6d.jpeg",
      BASE + "detailsRangeRover%20(1).7da755bfd9b170b10af1.jpg",
      BASE + "detailsRangeRover%20(2).c1b9279f3c08defc9342.jpg",
      BASE + "detailsRangeRover%20(3).2b0c204763c828eb19d4.jpg",
      BASE + "detailsRangeRover%20(4).ad41086ad68de9527dee.jpg",
      BASE + "detailsRangeRover%20(5).c99372d4a7582961ee3c.jpg",
      BASE + "detailsRangeRover%20(6).9b869a72d581bfa929f6.jpg",
    ],
  },
];

export default seedCars;
